import React from 'react';
import { Picker, Switch } from 'antd-mobile';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import './MemberDiscount.less';


export class MemberDiscount extends CommonComponent {
  constructor(props) {
    super(props);
    this.options = this.props.options;

    this.state = {
      discountType: [{          // 优惠类型+优惠对应的数据 默认全部开启 value是优惠列表数据
        label: 'coupon',
        value: []
      }, {
        label: 'vip',
        value: []
      }, {
        label: 'integral',
        value: []
      }], 
      isVisibled: false,         // 弹窗开关
      isShowTip: true,           // 是否显示提示语 默认开启
      tipName: '',               // 提示语
      selectedDiscount: {},      // 选中的优惠
      currentDiscount: {         // 当前选中优惠的类型和下标
        type: '',
        index: 0,
      },
      themeColor: {
        type: '',
        value: ''
      },
      isShowTarbar: true,
      currentTab: '',            // 当前选中的tab
      franchisee: '',            //子店ID
      appLogo: app.globalData.appLogo
    };
  }

  // 展示弹窗。小程序里面通过data里面的数据控制展示，这里是调用这个方法。参数和小程序一致
  show = (options) => {
    let {
      discountType,
      franchisee,
      afterSelectedDiscount
    } = options;

    this.setData({
      discountType: discountType,
      franchisee: franchisee
    });
    this.afterSelectedDiscount = afterSelectedDiscount;
  }

  showDialog = (selectedDiscount, franchisee = '') => {
    this.getAppECStoreConfig();
    let discountType = selectedDiscount.discount_type;
    let currentDiscount = this.data.currentDiscount;
    let currentTab = this.data.currentTab;
    let num = 0;
    
    if(!discountType){
      let discount_type = '';
      this.data.discountType.map((val) => {
        if(val.value.length > 0){
          discount_type = val.label
          num++
        }
      })
      this.setData({
        isVisibled: true,
        selectedDiscount: {
          discount_type: discount_type,
          franchisee: franchisee
        },
        currentTab: discount_type,
        currentDiscount: {
          type: '',
          index: 0,
        },
        isShowTarbar: num !== 1
      })
      return;
    }
    this.data.discountType.map((val) => {
      if(val.label === discountType || (val.label === 'vip' && discountType === 'paid_vip') || (val.label === 'vip' && discountType === 'vip_benefit_day')){
        if(selectedDiscount.no_use_benefit === 1){
          currentDiscount = {
            type: '',
            index: 0
          }
          currentTab = discountType;
          return;
        }
        if(discountType === 'coupon'){
          val.value.forEach((item, index) => {
            if(item.coupon_id == selectedDiscount.coupon_id){
              currentDiscount = {
                type: 'coupon',
                index: index
              };
            }
          })
          currentTab = 'coupon';
        } else if(discountType === 'vip' || discountType === 'paid_vip' || discountType === 'vip_benefit_day') {
          val.value.forEach((item, index) => {
            if(item.vip_id == selectedDiscount.vip_id && item.discount_type == selectedDiscount.discount_type){
              currentDiscount = {
                type: 'vip',
                index: index
              };
              currentTab = 'vip';
            }
          })
        } else if(discountType === 'integral') {
          currentDiscount = {
            type: 'integral',
            index: 0
          };
          currentTab = 'integral';
        }
      }
      if(val.value instanceof Array && val.value.length > 0){
        num++
      }
    })
    this.tipNameInit();
    this.setData({
      isVisibled: true,
      selectedDiscount: selectedDiscount,
      currentDiscount: currentDiscount,
      currentTab: currentTab,
      isShowTarbar: num !== 1
    })
  }

  tipNameInit = () => {
    let tipName = [];
    this.data.discountType.map((val) => {
      if (val.label === 'coupon' && val.value.length) {
        tipName.push('优惠券');
      } else if (val.label === 'vip' && val.value.length) {
        tipName.push('会员卡');
      } else if (val.label === 'integral' && val.value.length) {
        tipName.push('积分');
      }
    })
    this.setData({
      tipName: tipName.length > 1 ? tipName.join('、') : ''
    })
  }

  // 选择优惠
  selectedDiscount = (e) => {
    let type = e.currentTarget.dataset.type;
    let index = +e.currentTarget.dataset.index;
    let disabled = e.currentTarget.dataset.disabled || false;
    let selectedDiscount = this.data.selectedDiscount;
    let currentDiscount = this.data.currentDiscount;
    if (disabled) { return; }

    this.data.discountType.map((val) => {
      if (val.label === type) {
        if(type === currentDiscount.type && index === currentDiscount.index){    // 反选不使用优惠
          if(selectedDiscount.type === 'combine'){
            selectedDiscount.no_use_benefit = 1;
          }else {
            selectedDiscount = {
              title: "不使用优惠",
              name: '无',
              no_use_benefit: 1
            };
          }
          currentDiscount = {
            type: '',
            index: 0,
          }
        }else {
          if(selectedDiscount.type === 'combine'){
            selectedDiscount.no_use_benefit = 0;
            selectedDiscount.discount_type === 'coupon' ? selectedDiscount.coupon_id = val.value[index].coupon_id : '';
            if(selectedDiscount.discount_type === 'vip' || selectedDiscount.discount_type === 'paid_vip' || selectedDiscount.discount_type === 'vip_benefit_day'){
              selectedDiscount.discount_type = val.value[index].discount_type
              selectedDiscount.vip_id = val.value[index].vip_id
            }
          }else {
            selectedDiscount = val.value[index];
          }
          currentDiscount = {
            type: type,
            index: index
          }
        }

        this.setData({
          selectedDiscount: selectedDiscount,
          currentDiscount: currentDiscount
        })
      }
    })

    this.afterSelectedDiscount && this.afterSelectedDiscount({ selectedDiscount: selectedDiscount });

    this.setData({
      isVisibled: false
    })
  }

  hiddenDialog = (e) => {
    this.setData({
      isVisibled: false
    })
  }

  // 不使用优惠
  noUseDiscount = () => {
    let selectedDiscount = this.data.selectedDiscount;
    if(selectedDiscount.type === 'combine'){
      selectedDiscount.no_use_benefit = 1;
    }else {
      selectedDiscount = {
        title: "不使用优惠",
        name: '无',
        no_use_benefit: 1
      };
    }
    this.setData({
      selectedDiscount: selectedDiscount,
      currentDiscount: {
        type: '',
        index: 0,
      },
      isVisibled: false
    })
    this.afterSelectedDiscount && this.afterSelectedDiscount({ selectedDiscount: selectedDiscount });
  }

  // 导航选择
  checkType = (e) => {
    e.stopPropagation();
    let label = e.currentTarget.dataset.label;

    this.setData({
      currentTab: label
    });
  }


  isShowTipChange = () => {
    this.setData({ isShowTip: false })
  }

  // 获取用户会员卡信息
  getVipCardInfo = () => {
    let _this = this;
    app.sendRequest({
      url: '/index.php?r=AppShop/GetVIPInfo',
      data: {
        sub_shop_app_id: _this.data.franchisee
      },
      hideLoading: true,
      success: (res) => {
        let discountType = _this.data.discountType;
        discountType.map((val) => {
          if(val.label === 'vip'){
            // val.value[0].logo = res.data.logo
          }
        })
        _this.setData({
          discountType: discountType
        })
      }
    })
  }

  getAppECStoreConfig = () => {
    app.getAppECStoreConfig((res) => {
      this.setData({
        themeColor: res.color_config.theme
      })
    }, this.data.franchiseeId);
  }

  
  render() {
    const {
      isVisibled,
      selectedDiscount,
      isShowTip,
      tipName,
      themeColor,
      isShowTarbar,
      currentTab,
      discountType,
      currentDiscount,
      appLogo
    } = this.state;

    if(!isVisibled){
      return null;
    }
    return (
      <React.Fragment>
        <div className="common-component member-discount">
          {isVisibled && 
            <div>
              <div className="discount-wrapper">
                <div className="title">
                  <span className="title-text">请选择{ 
                    selectedDiscount.type !== 'combine' ? '会员优惠' : 
                    selectedDiscount.discount_type === 'vip' || selectedDiscount.discount_type === 'paid_vip' || selectedDiscount.discount_type === 'vip_benefit_day' ? '会员卡优惠' :
                    selectedDiscount.discount_type === 'coupon' ? '优惠券优惠' :
                    selectedDiscount.discount_type === 'integral' ? '积分优惠' : '会员优惠'}</span>
                  <div className="ico-moon icon-closes" onClick={this.hiddenDialog}></div>
                </div>
                {/* 自定义优惠时，不显示提示 */}
                {isShowTip && tipName !== '' && <div className="tip-mess" style={{color: themeColor, backgroundColor: themeColor + '33'}} >           
                  <span className="ico-moon icon-remind"></span>
                  <span>只能选用会员卡或优惠券其中一种，作为会员优惠使用。</span>
                  <div className="ico-moon icon-closes" onClick={this.isShowTipChange}></div>
                </div>}
                <div className="tab">
                  {isShowTarbar && <div className="tab-bar">{
                    discountType.length > 0 &&  discountType.map((item, index) => (
                        <div className={`tab-item ${item.label === currentTab ? 'active' : ''}`} key={item.label} hidden={ item.value.length < 1 } data-label={item.label} onClick={this.checkType}>
                        <span className="tab-item-text" style={item.label === currentTab ? {color: themeColor, borderColor: themeColor} : {}}>{item.label === 'coupon' ? '优惠券' : item.label === 'vip' ? '会员卡' : item.label === 'integral' ? '积分' : ''}</span>
                        </div>
                    ))
                  }
                  </div>}
                  <ScrollView scroll-y="true" className="my-coupon my-discount" hidden={currentTab !== 'coupon'}>
                    {
                      discountType.map((type, typeIndex) => (
                        type.label === 'coupon' && (
                          <div key={typeIndex}>
                            {
                              type.value.map((item, index) => (
                                <div className="coupon-item" key={index} style={{borderTop: `.08rem solid ${ currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#FF4D65' : '#d9d9d9' }`}} data-type="coupon" data-index={index} data-disabled={item.disabled} onClick={this.selectedDiscount}>
                                  <div className="info" style={{color: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#666' : '#ccc' }}>
                                    <div className="coupon-title text-overflow" style={{color: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#333' : '#ccc' }}>{item.title}</div> 
                                    { item.type == 0 && <div className="use-condition">使用条件：满{ item.condition }元，减{ item.value }元</div> }
                                    { item.type == 1 && <div className="use-condition">使用条件: 打{ item.value }折</div> }
                                    { item.type == 2 && <div className="use-condition">使用条件：可抵扣{ item.value }元</div> }
                                    { item.type == 3 &&<div className="use-condition">
                                      {
                                        item.extra_condition == '' ? <span>使用条件: 直接兑换{ item.coupon_goods_info && item.coupon_goods_info.title } </span> : 
                                        ( item.extra_condition.price ? <span>使用条件: 消费满{ item.extra_condition && item.extra_condition.price }元可兑换{ item.coupon_goods_info && item.coupon_goods_info.title }</span> : 
                                        ( item.extra_condition.goods_id ? <span>使用条件: 购买{ item.condition_goods_info && item.condition_goods_info.title }可兑换{ item.coupon_goods_info && item.coupon_goods_info.title }</span> : '' ))
                                      }
                                      </div> }
                                    { item.type == 4 && <div className="use-condition">使用条件: 储值金可充值{ item.value }元</div> }
                                    { item.type == 5 && <div className="use-condition">使用条件: { item.extra_condition }</div> }
                                    { currentDiscount.type === 'coupon' && currentDiscount.index === index && <div className="ico-moon icon-success-tip"></div> }
                                    { !(currentDiscount.type === 'coupon' && currentDiscount.index === index) && <div className="icon-no-use"></div> }
                                    <div className="background-word-area" style={{border: `2rpx solid ${ currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#FF4D65' : '#ccc' }`}}>
                                      <div className="background-circle" style={{background: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#FF4D65' : '#ccc' }}></div>
                                      { item.type == 0 && <div className="background-word">减</div> }
                                      { item.type == 1 && <div className="background-word">折</div> }
                                      { item.type == 2 && <div className="background-word">代</div> }
                                      { item.type == 3 && <div className="background-word">兑</div> }
                                      { item.type == 4 && <div className="background-word">储</div> }
                                      { item.type == 5 && <div className="background-word">通</div> }
                                    </div>
                                    <div className="time-block">
                                      <div className="effective-time" style={{color: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#999' : '#ccc' }}>{ item.active_title }</div>
                                      {!item.disabled && item.expire_day_count && <div className="maturity-time" style={{color: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#FF4D65' : '#ccc' }}>{ item.expire_day_count }天后即将过期 </div> }
                                      {item.disabled && <div className="disabled-text" style={{ color: themeColor }}>{item.cant_use_reason}</div>}
                                    </div> 
                                  </div>
                                </div>
                              ))
                            }
                            {
                              type.value.length === 0 && <div className="empty">
                                <img src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/empty.png" />  
                                暂无任何数据
                              </div>
                            }
                          </div>
                        )
                      ))
                    }
                  </ScrollView>
                  <ScrollView scroll-y="true" className="my-card my-discount" hidden={currentTab !== 'vip'}>
                    {
                      discountType.map((type, typeIndex) => (
                        type.label === 'vip' && (
                          <div key={typeIndex}>
                            {
                              type.value.map((item, index) => (
                                <div className="card-item" key={index} data-type="vip" data-index={index} onClick={this.selectedDiscount} style={{backgroundImage: "url('http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/vip-card-default.png')"}}>
                                  <div className="card-img-block" style={{border: `6rpx solid ${item.logo ? '#ffc790' : '#fff' }`}}>
                                    {
                                      item.logo ? <img className="card-img" src={item.logo} /> : <img className="app-logo-img" src={appLogo} />
                                    }                              
                                  </div>
                                  <div className="card-info">
                                    <div className="card-name text-overflow">{ item.app_name + ' ' + item.name } </div>
                                    { item.discount != 0 && <div className="card-mess text-overflow">可享 { item.discount }折</div> }
                                  </div>
                                  <div className="card-btn">{ currentDiscount.type === 'vip' && currentDiscount.index === index ? '使用中' : '立即使用' }</div>
                                </div>
                              ))
                            }
                            {
                              type.value.length === 0 && <div className="empty">
                                <img src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/empty.png" />  
                                暂无任何数据
                              </div>
                            }
                          </div> 
                        )
                      ))
                    }
                  </ScrollView>
                  <ScrollView scroll-y="true" className="my-integral my-discount" hidden={currentTab !== 'integral'}>
                    {
                      discountType.map((type, typeIndex) => (
                        type.label === 'integral' && (
                          <div key={typeIndex}>
                            {
                              type.value.map((item, index) => (
                                <div className="integral-item" key={index} style={{borderTop: `8rpx solid ${ currentDiscount.type === 'integral' && currentDiscount.index === index ? '#FF4D65' : '#d9d9d9' }`}} data-type="integral" data-index={index} onClick={this.selectedDiscount}>
                                  <div className="info" style={{color: currentDiscount.type === 'integral' && currentDiscount.index === index ? '#333' : '#ccc' }}>
                                    <div className="integral-title">积分抵扣 <span className="red-text" style={{color: currentDiscount.type === 'integral' && currentDiscount.index === index ? '#FF4D65' : '#ccc' }}>{item.max_can_use_integral}积分可用</span></div> 
                                    <div className="use-condition">积分使用 : 100积分 抵1元</div>
                                    { currentDiscount.type === 'integral' && currentDiscount.index === index && <div className="ico-moon icon-success-tip"></div> }
                                    { !(currentDiscount.type === 'integral' && currentDiscount.index === index) && <div className="icon-no-use"></div>}
                                    <div className="background-word-area" style={{border: `2rpx solid ${ currentDiscount.type === 'integral' && currentDiscount.index === index ? '#FF4D65' : '#ccc' }`}}>
                                      <div className="background-circle" style={{background: currentDiscount.type === 'integral' && currentDiscount.index === index ? '#FF4D65' : '#ccc' }}></div>
                                      <div className="background-word">积</div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            }
                            {
                              type.value.length === 0 && <div className="empty">
                                <img src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/empty.png" />  
                                暂无任何数据
                              </div>
                            }
                          </div>
                        )
                      ))
                    }
                  </ScrollView>
                  <div className="no-use-btn" onClick={this.noUseDiscount}>不使用该优惠</div>
                </div>
              </div>
            </div>
          }
          </div>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/member-discount/MemberDiscount.jsx